define('app/views/timer_view',['app/setup', 'flip-clock'], function(takhfifan, flipClock) {
  takhfifan.TimerView = Backbone.View.extend({
    timerFlag: true,
    initialize: function(attrs) {
      var _this = this;
      var dealId = attrs.dealId;

      takhfifan.eventHub.on('dealseconds:' + dealId, function(seconds) {
        _this.model.setTimeRemaining(seconds);
      });

      this.model.on('change:seconds', this.render, this);
      // this.render();
    },
    render: function(args) {
      var clockValue,
        clockWrapper = this.$el.find('.deal-countdown'),
        _this = this,
        clickOptions ={
          autoStart: true,
          countdown: true,
          language: 'persian',
          clockFace: 'MinuteCounter',
          callbacks :{
            stop: function() {
              if(_this.model.get('seconds') > 0){
                takhfifan.eventHub.trigger('timeover:' + _this.model.get('dealId'));
              }
            }
          }
        };

      if (_.isUndefined(this.model.get('seconds'))) {
        clockValue = 0;
      }
      else{
        if(!$('.deal-details-single.expired').length){
          clockValue = this.model.get('seconds');
        }
        else{
          clockValue = 0;
        }
        this.$el.find('.deal-timer-loading').fadeOut(function() {
          $(this).remove();
        })
      }

      this.$el.find('.deal-timer-loading').fadeOut(function() {
        $(this).remove();
      });

      if(clockValue===0){
        clickOptions.autoStart = false;
      }

      if(this.model.get('days') < 1){
        clickOptions.clockFace = 'HourlyCounter';
      }else{
        clickOptions.clockFace = 'DailyCounter';
        clickOptions.showSeconds= false;
      }
      this.clock = new FlipClock(clockWrapper, clockValue, clickOptions);
    },
    refresh: function () {
      var seconds=this.model.get('seconds');
      if (!_.isUndefined(seconds)) {
        this.$el.find('.deal-timer-loading').fadeOut(function() {
          $(this).remove();
        });
      }else{
        seconds = 0;
      }

      if(parseInt(seconds / 86400,10) < 1){
        if(this.timerFlag === true){
          this.clock.loadClockFace('HourlyCounter');
          this.timerFlag = false;
        }
      }
      else{
        this.clock.loadClockFace('DailyCounter', {
          showSeconds: false
        });
      }
      this.clock.setTime(seconds);
      this.clock.start();
    }
  });

});

